import { render, staticRenderFns } from "./HeaderOnlyLogo.vue?vue&type=template&id=8cf187b6&scoped=true&"
var script = {}
import style0 from "./HeaderOnlyLogo.vue?vue&type=style&index=0&id=8cf187b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf187b6",
  null
  
)

export default component.exports